



















import { isNil } from 'ramda'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { fetchExamRoomList, completion } from '@/service/exam/room'
import { randKey } from '@/utils/random'
import { ExamRoom } from '@/models/exam/room'
import { Nilable } from '@/models/helpers/common'

@Component
export default class ExamRoomSelect extends Vue {
  @Prop({ type: String }) exam!: string
  @Prop({ type: String }) examRoom!: Nilable<string>

  rooms = [] as ExamRoom[]
  randKey = randKey()
  loading = true

  get disabled() {
    return isNil(this.exam)
  }

  get placeholder() {
    return this.disabled ? '请先选择考试' : '请选择考场'
  }

  get roomsWithName() {
    return this.rooms.map(completion)
  }

  @Watch('exam', { immediate: true })
  async handleExamChange() {
    this.loading = true
    this.handleSelectChange(null)
    this.rooms = await fetchExamRoomList(this.exam)
    this.loading = false
  }

  handleSelectChange(id: Nilable<string>) {
    this.$emit('update:examRoom', id)

    const room = this.rooms.find(a => a.id === id)
    this.$emit('change', room || { id: null })
  }
}
